// Page Access grants (/admin/access): admins can let extra roles or specific
// people open a page on top of the roles it declares in RouteHandler.js.
// The server works out which grants apply to the signed-in user and the live
// session poll (utils/liveSession.js) stores them as `grantedPaths` next to
// the roles in the role slice.
//
// grantKey must match server/lib/routeAccess.js: lowercased, leading slash,
// no query/trailing slash, trailing :param segments dropped — so a grant on
// /safety/training also covers /safety/training/:id.
export const grantKey = (path) => {
  const segments = String(path || "")
    .split(/[?#]/)[0]
    .toLowerCase()
    .split("/")
    .filter(Boolean);
  while (segments.length && segments[segments.length - 1].startsWith(":")) {
    segments.pop();
  }
  return `/${segments.join("/")}`;
};

export const isPathGranted = (path, grantedPaths) =>
  Boolean(path && grantedPaths?.length && grantedPaths.includes(grantKey(path)));
